import clients from './clients';
import compliance from './compliance';
import engagement from './engagement';
import menu from './menu';
import prospect from './prospect';
import task from './task';

let messages = Object.assign({}, clients, compliance, engagement, menu, prospect, task);

export default messages;
